var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchaeologicalSites({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3806_12121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 4.5C25.9036 4.5 31.5 10.0964 31.5 17C31.5 23.9036 25.9036 29.5 19 29.5C12.0964 29.5 6.5 23.9036 6.5 17C6.5 10.0964 12.0964 4.5 19 4.5Z",
    fill: "#B54900",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 9.66699C21.3681 9.66699 21.6668 9.96497 21.667 10.333C21.667 10.655 21.4384 10.924 21.1348 10.9863L21 11V11.667H21.667C22.1973 11.6671 22.7061 11.8779 23.0811 12.2529C23.4559 12.628 23.667 13.1367 23.667 13.667C23.6669 14.1973 23.4561 14.7061 23.0811 15.0811C22.9488 15.2134 22.7983 15.3227 22.6377 15.4121C22.7542 15.5573 22.8649 15.7081 22.9639 15.8672C23.4238 16.6073 23.6674 17.4616 23.667 18.333C23.667 19.8376 23.1016 21.1384 22.3721 22.1416C22.1442 22.4549 21.8954 22.7406 21.6406 23H23C23.3682 23 23.667 23.2988 23.667 23.667C23.6668 24.035 23.3681 24.333 23 24.333H15C14.6319 24.333 14.3332 24.035 14.333 23.667C14.333 23.2988 14.6318 23 15 23H16.3594C16.1049 22.7406 15.8565 22.4548 15.6289 22.1416C14.9 21.1386 14.3354 19.8386 14.333 18.335V18.334C14.3324 17.4623 14.5761 16.6075 15.0361 15.8672C15.1348 15.7084 15.2441 15.5571 15.3604 15.4121C15.2003 15.3229 15.0508 15.2129 14.9189 15.0811C14.5908 14.7529 14.3883 14.322 14.3428 13.8643L14.333 13.667C14.333 13.1367 14.5441 12.628 14.9189 12.2529C15.2939 11.8779 15.8027 11.6671 16.333 11.667H17V11L16.8652 10.9863C16.5617 10.924 16.333 10.655 16.333 10.333C16.3332 9.96497 16.6319 9.667 17 9.66699H21ZM18.333 11V14.0879C18.333 14.6676 17.9663 15.1243 17.5254 15.3408H17.5244C17.3988 15.4028 17.2781 15.4731 17.1621 15.5498C17.1586 15.5522 17.1549 15.5543 17.1514 15.5566C16.7566 15.8199 16.4211 16.1655 16.1689 16.5713C15.8405 17.0999 15.6667 17.7097 15.667 18.332C15.6687 19.4947 16.1047 20.5282 16.708 21.3584C17.2704 22.1321 17.9567 22.6962 18.5029 23H19.4971C20.0437 22.6961 20.7312 22.132 21.2939 21.3584C21.8976 20.5283 22.333 19.495 22.333 18.333L22.3252 18.0996C22.2876 17.5587 22.1185 17.0338 21.8311 16.5713C21.5024 16.0426 21.032 15.616 20.4736 15.3408L20.3125 15.249C19.9475 15.0085 19.667 14.595 19.667 14.0879V11H18.333ZM16.333 13C16.1564 13.0001 15.9872 13.0705 15.8623 13.1953C15.7373 13.3203 15.667 13.4902 15.667 13.667L15.6699 13.7324C15.685 13.8851 15.7529 14.0283 15.8623 14.1377C15.9873 14.2626 16.1563 14.3329 16.333 14.333H16.5957C16.7067 14.2662 16.8197 14.2021 16.9365 14.1445L16.9375 14.1436C16.9657 14.1297 16.9848 14.1121 16.9941 14.0986C17.0021 14.0869 17 14.0835 17 14.0879V13H16.333ZM21 14.0879C21 14.0835 20.9987 14.0867 21.0068 14.0986C21.0115 14.1054 21.0181 14.1142 21.0273 14.1221L21.0625 14.1445C21.1796 14.2022 21.293 14.2661 21.4043 14.333H21.667C21.8437 14.3329 22.0127 14.2626 22.1377 14.1377C22.2626 14.0127 22.3329 13.8437 22.333 13.667C22.333 13.4902 22.2627 13.3203 22.1377 13.1953C22.0283 13.086 21.885 13.018 21.7324 13.0029L21.667 13H21V14.0879Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3806_12121",
    x: 0,
    y: 0,
    width: 38,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3806_12121"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3806_12121",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchaeologicalSites);
export default __webpack_public_path__ + "static/media/archaeological_sites.8310e45fe5ac8d82f54191f816485086.svg";
export { ForwardRef as ReactComponent };